import { defineMessages } from 'react-intl-next';

export const messages: {
    unsplashApiBadStatusErrorMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    }; unsplashApiNoNetworkErrorMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    }; unsplashApiRateLimitedErrorMessage: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	unsplashApiNoNetworkErrorMessage: {
		id: 'company-hub.company-hub-common.unsplash.search.error.no-network-message',
		defaultMessage: 'We’ve lost the connection. Try again.',
		description:
			'Message for error shown to user when an api request made to Unsplash fails because the network appeared to be offline',
	},
	unsplashApiBadStatusErrorMessage: {
		id: 'company-hub.company-hub-common.unsplash.error.bad-request-message',
		defaultMessage: 'We can’t get a response from Unsplash. Refresh and try again.',
		description:
			'Message for error shown to user when an api request made to Unsplash fails because the request was unsuccessful for reasons other than network or rate limit',
	},
	unsplashApiRateLimitedErrorMessage: {
		id: 'company-hub.company-hub-common.unsplash.error.rate-limited-message',
		defaultMessage: 'We can’t get a response from Unsplash. Wait a moment, then try again.',
		description:
			'Message for error shown to user when an api request made to Unsplash fails because too many requests were sent to Unsplash in a given period',
	},
});
